import { tryCatchHelper } from '../../../../helpers';
import { oneMatriculasAction } from '../MatriculasAction';
import {
  ACTIVO_MAT_SECCIONES,
  ALL_MAT_SECCIONES,
  LOADING_ALL_MAT_SECCIONES,
} from './MatSeccionesReducer';
import {
  allMatSeccionesService,
  deleteMatSeccionesService,
  saveMatSeccionesService,
} from './MatSeccionesService';

export const allMatSeccionesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_MAT_SECCIONES, payload: true });
    const res = await allMatSeccionesService(params);
    dispatch({
      type: ALL_MAT_SECCIONES,
      payload: res.data.data,
    });
    dispatch({ type: LOADING_ALL_MAT_SECCIONES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_MAT_SECCIONES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveMatSeccionesAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveMatSeccionesService(id, data);
    notify(res.data.message);
    await oneMatriculasAction(dispatch, data.idMatricula);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoMatSeccionesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_MAT_SECCIONES, payload: data });
};

export const deleteMatSeccionesAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteMatSeccionesService(id);
    await setActivoMatSeccionesAction(dispatch, null);
    notify(res.data.message);
    await oneMatriculasAction(dispatch, params.idMatricula);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};
